var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked 1",
    clipPath: "url(#clip0_4091_17444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C13.4578 60 0 46.5422 0 30C0 13.4578 13.4578 0 30 0C46.5422 0 60 13.4577 60 30C60 46.5423 46.5422 60 30 60ZM41.7108 21.8203C41.3939 21.5037 40.9642 21.3259 40.5162 21.3259C40.0683 21.3259 39.6386 21.5037 39.3217 21.8203L26.5462 34.5949L20.6789 28.7259C20.5223 28.567 20.3358 28.4405 20.1302 28.354C19.9245 28.2675 19.7037 28.2225 19.4806 28.2217C19.2575 28.2209 19.0364 28.2643 18.8301 28.3494C18.6238 28.4345 18.4364 28.5596 18.2788 28.7175C18.1211 28.8754 17.9962 29.0629 17.9114 29.2693C17.8265 29.4757 17.7834 29.6968 17.7845 29.9199C17.7855 30.1431 17.8308 30.3638 17.9175 30.5693C18.0043 30.7749 18.131 30.9612 18.2902 31.1176L25.3521 38.1797C25.6692 38.4965 26.0992 38.6744 26.5474 38.6744C26.9957 38.6744 27.4256 38.4965 27.7427 38.1797L41.7115 24.2109C41.8686 24.054 41.9932 23.8677 42.0782 23.6625C42.1632 23.4574 42.2069 23.2375 42.2069 23.0155C42.2068 22.7934 42.163 22.5736 42.0778 22.3685C41.9927 22.1634 41.868 21.9771 41.7108 21.8203Z",
    fill: "#007D23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_17444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked 1.1ec12f59264c7aff0ef411c15dec92d4.svg";
export { ForwardRef as ReactComponent };